import React from 'react';
import PropTypes from 'prop-types';
import { Icon, Div, Text } from '@pinpoint/design-kit';

import BaseDialog from './base';
/* eslint-disable react/prop-types */

function ApprovalLiftChartDialog({ isOpen, actions }) {
  return (
    <BaseDialog
      isOpen={isOpen}
      hideCloseIcon
      actions={actions}
      title={{
        text: `Download Predictions and Actuals`,
        backgroundColor: 'talLime',
        color: 'white',
        textSize: 'title',
        icon: <Icon name="AlertSolid" color="white" viewBox="0 0 24 24" size="3.125rem" m={{ r: '1rem' }} />,
      }}
      items={{
        content: [
          <Div d="flex" align="center">
            <Icon name="AlertSolid" color="marigold" viewBox="0 0 24 24" size="1.5rem" m={{ r: '0.5rem', b: '1rem' }} />
            <Text
              textSize="paragraph"
              textWeight="500"
              textColor="marigold"
              m={{ b: '1rem' }}
              style={{ lineHeight: '1.25rem' }}
            >
              I understand this download is strictly for internal Pinpoint analytics only
            </Text>
          </Div>,
        ],
        buttons: [
          {
            text: 'ACCEPT',
            textSize: 'body',
            close: true,
          },
        ],
      }}
    />
  );
}

/* eslint-disable react/require-default-props */
ApprovalLiftChartDialog.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  actions: PropTypes.shape({
    cancel: PropTypes.shape({
      before: PropTypes.func,
      on: PropTypes.func.isRequired,
      after: PropTypes.func,
    }).isRequired,
    close: PropTypes.shape({
      before: PropTypes.func,
      on: PropTypes.func.isRequired,
      after: PropTypes.func,
    }).isRequired,
    handlers: PropTypes.arrayOf(
      PropTypes.shape({
        before: PropTypes.func,
        on: PropTypes.func.isRequired,
        after: PropTypes.func,
      })
    ),
  }).isRequired,
  title: PropTypes.shape({
    text: PropTypes.string.isRequired,
    textSize: PropTypes.string,
    backgroundColor: PropTypes.string.isRequired,
    color: PropTypes.string,
  }),
  items: PropTypes.shape({
    content: PropTypes.arrayOf(PropTypes.element).isRequired,
    buttons: PropTypes.arrayOf(
      PropTypes.shape({
        text: PropTypes.string.isRequired,
        textSize: PropTypes.string,
        close: PropTypes.bool.isRequired,
      }).isRequired
    ),
  }),
};
/* eslint-enable */

export default ApprovalLiftChartDialog;
